module.exports = __webpack_public_path__ + "static/media/docmang2.9b5dca5e.png";